import { useOpenFeatureClientStatus } from '@openfeature/react-sdk'
import { Search, Typography, YStack } from '@shinetools/lumen-react'
import { useState } from 'react'

import {
  getRemoteFeatureFlagProviderError,
  isRemoteFeatureFlagsReady,
} from '@features/remoteFeatureFlags/initRemoteFeatureFlags'
import { useEnsureRemoteFeatureFlags } from '@features/remoteFeatureFlags/useEnsureRemoteFeatureFlags'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { DetailRow } from './elements/DetailRow'
import { RemoteFeatureFlagAccordion } from './elements/RemoteFeatureFlagAccordion'

export const RemoteFeatureFlags = () => {
  useEnsureRemoteFeatureFlags()
  const [search, setSearch] = useState('')
  const { organization } = useUserOrganization()
  const providerStatus = useOpenFeatureClientStatus()
  const datadogConfig = window.ENV?.datadogConfig

  const searchedKey = search.trim()

  return (
    <YStack gap={16} paddingVertical={16}>
      <Typography.Header as="h3">Provider</Typography.Header>
      <YStack gap={4}>
        <DetailRow label="Status">{providerStatus}</DetailRow>
        <DetailRow label="Registered">{isRemoteFeatureFlagsReady() ? 'yes' : 'no'}</DetailRow>
        <DetailRow label="Init error">{getRemoteFeatureFlagProviderError() ?? '—'}</DetailRow>
        <DetailRow label="organizationId (targetingKey)">{organization?.id ?? '—'}</DetailRow>
      </YStack>

      <Typography.Header as="h3">Flags</Typography.Header>
      <Search
        noDropdown
        onChange={(event) => setSearch(event.target.value)}
        placeholder="Type the exact flag key"
        value={search}
      />
      {searchedKey && <RemoteFeatureFlagAccordion flagKey={searchedKey} key={searchedKey} />}

      <Typography.Header as="h3">Datadog config</Typography.Header>
      <YStack gap={4}>
        <DetailRow label="env">
          {datadogConfig?.env ?? '—'} (development / staging / production — must match Datadog Feature Flags, same as
          e-invoicing DD_ENV)
        </DetailRow>
        <DetailRow label="service">{datadogConfig?.service ?? '—'}</DetailRow>
        <DetailRow label="site">{datadogConfig?.site ?? '—'}</DetailRow>
        <DetailRow label="theme">{window.ENV?.theme ?? '—'}</DetailRow>
        <DetailRow label="applicationId">{datadogConfig?.applicationId ? 'set' : 'missing'}</DetailRow>
        <DetailRow label="clientToken">{datadogConfig?.clientToken ? 'set' : 'missing'}</DetailRow>
      </YStack>
    </YStack>
  )
}
